<template>
  <v-app style="background:#353535">
    <meta
      name="description"
      content="Ihr günstiger, schneller und freundlicher JTL Freelancer."
    >

    <div class="page-content">
      <img
        class="logo"
        src="https://basar.karobube.com/bilder/intern/shoplogo/karobubeWhite.png"
        alt="Karobube"
      >

      <div class="word-cloud-wrap">
        <p class="word-cloud-text">
          JTL-Freelancer mit 6 Jahren Erfahrung, über 50 Kunden, und hunderten gelösten
          Problemen und entwickelten Lösungen in allen Bereichen rund um JTL.
        </p>

        <p class="word-cloud-cloud">
JTL-Support, JTL-WAWI, JTL-WMS, JTL-POS, JTL-FFN, FFN-Connect,
Workflows, Eigene&nbsp;Übersichten, DotLiquid, SQL, Druckvorlagen, List&amp;Label,
Mailvorlagen, HTML, CSS, Java, Javascript, Python, Batch, Powershell,
Automatisierungen, Schnittstellen, APIs, Exporte,
Geschäftsberichte, IT-Beratung, White-Label
</p>

        
      </div>

      <div class="contact-row">
  <v-btn
    class="contact-btn"
    outlined
    color="white"
    :href="'http://wa.me/4916093457665'"
  >
    WhatsApp
  </v-btn>

  <v-btn
    class="contact-btn"
    outlined
    color="white"
    :href="'mailto:contact@karobube.com'"
  >
    contact@karobube.com
  </v-btn>

  <v-btn
    class="contact-btn"
    outlined
    color="white"
    :href="'tel:004964213800306'"
  >
    06421 3800 306
  </v-btn>
</div>
      <div class="bottom-right">
        <v-btn text color="white" to="/Impressum">
          Impressum
        </v-btn>
        <v-btn text color="white" to="/Datenschutz">
          Datenschutz
        </v-btn>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'Home'
};
</script>

<style scoped>
.page-content {
  --content-width: min(92vw, 500px);

  text-align: center;
  padding: 0 1rem 4rem;
}

.logo {
  width: var(--content-width);
  max-width: 100%;
  margin: 5% auto 1.5rem;
  display: block;
}

.word-cloud-wrap {
  color: white;
  width: var(--content-width);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.word-cloud {
  width: 100%;
  margin: 0;
}

.word-cloud-spans {
  text-align: justify;
  line-height: 1.9;
}

.word-cloud-spans::after {
  content: "";
  display: inline-block;
  width: 100%;
}

.word-cloud-spans span {
  display: inline-block;
  margin: 0 10px 0 0;
  white-space: nowrap;
}

.word-cloud-text {
  width: 100%;
  margin: 0.6rem 0 0;
  color: white;
  text-align: justify;
  line-height: 1.6;
}

.word-cloud-cloud {
  width: 100%;
  margin: 0.4rem 0 0;
  color: white;
  text-align: justify;
  line-height: 1.6;
}

.contact-row {
  width: var(--content-width);
  margin: 1.25rem auto 0;

  display: flex;
  flex-direction: column;   /* stack vertically */
  gap: 12px;
}

.contact-btn {
  width: 100%;              /* full width */
  margin: 0 !important;
}

.privacy-text {
  color: white;
  width: var(--content-width);
  text-align: justify;
  margin: 1.7rem auto 0;
}

.bottom-right {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 1%;
}

@media (max-width: 600px) {
  .page-content {
    --content-width: calc(100vw - 2rem);
    padding: 0 1rem 2rem;
  }

  .logo {
    width: var(--content-width);
    margin: 2rem auto 1rem;
  }

  .word-cloud-spans {
    line-height: 1.8;
  }

  .word-cloud-spans span {
    margin: 0 8px 0 0;
  }

  .word-cloud-text {
    margin-top: 0.25rem;
  }

  .contact-row {
    width: var(--content-width);
    margin-top: 1rem;
  }

  .bottom-right {
    position: static;
    margin: 1rem 0 0;
    text-align: center;
  }
}
</style>